import React, { useState, useEffect, useCallback } from 'react';
import {
  Box,
  Typography,
  Drawer,
  Icon,
  IconButton,
  List,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';

import ActionsCourse from '../../store/ducks/course';
import { convertObjToArr, sortArrByKey } from '../../utils';
import Logo from '../Logo';
import CourseItem from './CourseItem';
import MenuItem from '../MenuItem';
import useStyles from './styles';

const MainMenu = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    router: {
      location: { pathname: routerPath },
    },
    course: { list: coursesObj, allCoursesLoaded, current },
    // product: { trainingsLabel, showAppointments, myTrainingsLabel },
    product: { trainingsLabel, myTrainingsLabel },
    // appointments: {
    //   infos: { daysToRealease: daysToAllowAppointments },
    // },
  } = useSelector(state => state);

  const [isOpen, setIsOpen] = useState(false);
  const [coursesArr, setCoursesArr] = useState([]);
  const [menuCourses, setMenuCourses] = useState([]);

  useEffect(() => {
    if (!allCoursesLoaded) {
      dispatch(ActionsCourse.requestCoursesList());
    }
  }, [allCoursesLoaded, dispatch]);

  useEffect(() => {
    setCoursesArr(sortArrByKey(convertObjToArr(coursesObj), 'name'));
  }, [coursesObj]);

  useEffect(() => {
    setMenuCourses(
      coursesArr.map(course => ({
        ...course,
        isActive: Number(course.id) === Number(current?.course),
      })),
    );
  }, [coursesArr, current]);

  const openDrawer = useCallback(
    open => event => {
      if (event) {
        if (
          event.type === 'keydown' &&
          (event.key === 'Tab' || event.key === 'Shift')
        ) {
          return;
        }
      }
      setIsOpen(open);
    },
    [],
  );

  const handleOpenMainMenu = useCallback(() => openDrawer(true)(), [
    openDrawer,
  ]);
  const handleCloseMainMenu = useCallback(() => openDrawer(false)(), [
    openDrawer,
  ]);

  useEffect(() => {
    handleCloseMainMenu();
  }, [handleCloseMainMenu, routerPath]);

  return (
    <>
      <IconButton className="icon-toolbar menu" onClick={handleOpenMainMenu}>
        <Icon>menu</Icon>
      </IconButton>
      <Drawer open={isOpen} onClose={handleCloseMainMenu}>
        <Box className={classes.container}>
          <Box className="header-container">
            <IconButton onClick={handleCloseMainMenu} className="header-close">
              <Icon>close</Icon>
            </IconButton>
            <Box className="header-logo-container">
              <Logo className="header-logo-img" />
            </Box>
          </Box>

          <List className="list-channels-container">
            <MenuItem path="/dashboard" title="Visão geral" icon="dashboard" />
            <MenuItem path="/list" title={trainingsLabel} icon="dvr" />
            {
              // removido temporariamente
              /* showAppointments && (
                <MenuItem
                  path="/appointments"
                  withSubPages
                  title="Agendamentos"
                  icon="contacts"
                  locked={daysToAllowAppointments > 0}
                  lockedMessage="Você ainda não tem acesso aos agendamentos."
                />
              ) */
            }
          </List>
          {!!coursesArr.length && (
            <>
              <Typography className="list-title" variant="overline">
                {myTrainingsLabel}
              </Typography>
              <List className="list-courses-container">
                {menuCourses.map(item => (
                  <CourseItem
                    key={item.id}
                    item={item}
                    isSelected={item.isActive}
                  />
                ))}
              </List>
            </>
          )}
        </Box>
      </Drawer>
    </>
  );
};

export default MainMenu;
